// Search box action button on the standalone search results page
// (sections/main-search.liquid). Mirrors the popup's icon toggle in
// assets/search.js (updateActionButton / handleActionClick): a magnifying glass
// while the field is empty, an X that clears the field once it has text.
// Unlike the popup, this input is pre-filled server-side with search.terms, so
// the button state is synced on init instead of assuming an empty field.
// This form is a plain GET form — no predictive fetching happens here.
class MainSearchForm {
  constructor(form) {
    this.form = form;

    if (this.form.dataset.mainSearchInit === 'true') return;

    this.input = form.querySelector('[data-main-search-input]');
    this.actionButton = form.querySelector('[data-main-search-action]');
    this.iconSearch = form.querySelector('[data-main-search-icon-search]');
    this.iconClear = form.querySelector('[data-main-search-icon-clear]');

    if (!this.input || !this.actionButton) return;

    this.form.dataset.mainSearchInit = 'true';

    this.labels = {
      search: this.actionButton.dataset.labelSearch || '',
      clear: this.actionButton.dataset.labelClear || '',
    };

    this.onInput = this.onInput.bind(this);
    this.onActionClick = this.onActionClick.bind(this);

    this.init();
  }

  init() {
    this.input.addEventListener('input', this.onInput);
    this.actionButton.addEventListener('click', this.onActionClick);

    this.updateActionButton(this.hasValue());
  }

  hasValue() {
    return this.input.value.trim().length > 0;
  }

  onInput() {
    this.updateActionButton(this.hasValue());
  }

  // The button is type="button" (see sections/main-search.liquid), so it never
  // intercepts the Enter key — only an actual click reaches this handler.
  // Enter always submits the form natively, regardless of the icon shown.
  onActionClick() {
    if (this.hasValue()) {
      this.input.value = '';
      this.updateActionButton(false);
      this.input.focus();
    } else {
      this.form.requestSubmit();
    }
  }

  // Swaps the action button between "search" (magnifying glass) and "clear" (X)
  // depending on whether the input has text.
  updateActionButton(hasValue) {
    if (this.iconSearch) this.iconSearch.hidden = hasValue;
    if (this.iconClear) this.iconClear.hidden = !hasValue;

    const label = hasValue ? this.labels.clear : this.labels.search;

    if (label) {
      this.actionButton.setAttribute('aria-label', label);
    }
  }
}

function initMainSearchForm(container = document) {
  const forms = container.querySelectorAll('[data-main-search-form]');

  forms.forEach((form) => {
    new MainSearchForm(form);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMainSearchForm();
});

document.addEventListener('shopify:section:load', (event) => {
  initMainSearchForm(event.target);
});
